import axios from 'axios';

import { apiBaseUrl } from '@/apis/appconst';


export async function loginUser(email, password) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/login`, { email, password });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}

export async function getMyDt(user_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/get_my_dt`, { user_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function delAcc(user_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/del_user`, { user_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function chPassNow(old_pass,new_pass,user_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/ch_pass_now`, { old_pass,new_pass,user_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function addBuss(busienss_id,busienss_user, busienss_name,  busienss_phone, busienss_address, 
    busienss_pincode, busienss_city, busienss_state, busienss_country, busienss_timezone ) {
    try {
        const response = await axios.post(`${apiBaseUrl}bussiness/update_profile`, { busienss_id, busienss_name, busienss_user, busienss_phone, busienss_address, 
            busienss_pincode, busienss_city, busienss_state, busienss_country, busienss_timezone  });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            error:error,
            message: "Authentication Failed"
        };
    }
}
export async function upAccess(user_id,user_access) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/update_access`, { user_id, user_access });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            error:error,
            message: "Authentication Failed"
        };
    }
}
export async function upSupEmail(user_id,support_email) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/update_access1`, { user_id, support_email });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            error:error,
            message: "Authentication Failed"
        };
    }
}
export async function regUser(name, email, password) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/signup`, { name, email, password });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function frogotUser(email) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/forgot_pass`, { email });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function getUsrList(page_no,limit,type,rtype) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/get_users`, { page_no,limit,type,rtype });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function getNotiList(page_no,limit,noti_user) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/get_noties`, { page_no,limit,noti_user });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function purPlan(user_plan_id, user_plan_title, user_plan_price, user_plan_duration, user_plan_date, 
    user_plan_client, user_plan_client1, user_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}user/purchase_plan`, { user_plan_id, user_plan_title, user_plan_price, user_plan_duration, user_plan_date, 
            user_plan_client, user_plan_client1, user_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}